<template lang="pug">
v-container.px-10(fluid)
  v-progress-linear(
    :active="loading",
    indeterminate,
    color="white",
    absolute,
    top
  )
  v-row(v-if="!loading")
    v-col.py-0
        v-row.pa-5
            v-col
                .section__title {{ $tc("Carrier._name", 1) }}
        v-row.pa-5
            v-col(cols="4")
                v-text-field(
                v-model="instance.name",
                :label="$t('Carrier.name')",
                :error-messages="errors['carrier.name']",
                )
            v-col(cols="4")
                v-text-field(
                v-model="instance.email",
                :label="$t('Carrier.email')",
                :error-messages="errors['carrier.email']",
                )
            v-col(cols="4")
                v-select(
                    :label="$t('Carrier.typeOfTransport')",
                    v-model="instance.typeOfTransport",
                    :items="transportTypes",
                    item-text="name",
                    item-value="name",
                    :error-messages="errors['carrier.typeOfTransport']",
                )
        v-row.pa-5
            v-col(cols="4")
                v-text-field(
                v-model="instance.externalId",
                :label="$t('Party.externalId')",
                disabled,
                )
            v-col(cols="4")
               app-datetime-picker(
                    :value="instance.createdAt",
                    :label="$t('Carrier.createdAt')",
                    disabled,
                    placeholder=" "
                )
            v-col(cols="4")
                app-datetime-picker(
                    :value="instance.modifiedAt",
                    :label="$t('Carrier.modifiedAt')",
                    disabled,
                    placeholder=" "
                )

</template>
<style >

.v-text-field--filled input {
  margin-top: 16px !important;
}
.v-text-field--filled > .v-input__control > .v-input__slot {
  min-height: inherit !important;
}
</style>
<script>
import axios from 'axios'
import EntityMixin from '@/mixins'

export default {
    name: 'entity-add',
    mixins: [EntityMixin],
    data: () => ({
        dialog: false,
        loading: false,
        searchResults: null,
        NoResults: true,
        businessScopes: [],
        where: null,
        transportTypes: [],
        whereList: null,
        timer: null,
        wait: 500,
    }),
    computed: {
        uid() {
            return this.$route.params.item
        },
        errors() {
            return this.$store.state.errors;
        }
    },
    methods: {
        async load() {
            if (this.uid) {
                try {
                    this.instance = (await axios.get(`Carrier/${this.uid}/`, {
                        _Entity: 'Carrier',
                        uid: this.uid
                    })).data
                    this.instance.entityState = 3;
                } catch (error) {
                    console.error(error)
                }
            } else {
                this.instance = {
                    businessScope: this.$store.state.user.user.businessScope,
                }
            }
        },
        //Load the list of transport types to populate the select dropdown
        async loadTransportTypes() {
          try {
            const endpoint = this.$fetchLoad(`TransportType`, true)
            this.transportTypes = (await axios.get(endpoint, { params: { pageSize: -1}})).data.data;
          } catch (error) {
            console.error(error);
          }
        },

    },
    async mounted() {
        this.loadTransportTypes();
    },
    async created() {
        await this.load()
    },
}
</script>

